module.exports = __webpack_public_path__ + "img/hero@2x.1912ec68.webp";